<!-- Entity information row: main Tax Attributes modal only -->
@if (ctx.modalName == 'taxAttribModal') {
<div [hidden]="ctx.minimise">
  <table style="width: 100%; margin-top: 10px;">
    <tbody>
      <tr>
        <td class="LayerLine1-clean" nowrap>Filing Tax Year:</td>
        <td class="LayerData1-clean" nowrap>{{ ctx.curentyear }}</td>
        <td class="LayerLine1-clean" nowrap>Entity:</td>
        <td class="LayerData1-clean" nowrap>
          {{ ctx.formDataObj.leid + " - " + ctx.formDataObj.taxCode + " - " + ctx.formDataObj.rp }}
        </td>
      </tr>
    </tbody>
  </table>
</div>
}
